import { Lightbulb } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { PREP_INTRO, PREP_GROUPS, PREP_QUOTE } from "@/lib/examPrep";

const slug = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const Body = ({ item }) => (
  <div className="space-y-3 text-sm leading-relaxed" style={{ color: "var(--ink-2)" }}>
    {item.body?.map((p) => <p key={p}>{p}</p>)}
    {item.list && <ul className="list-disc pl-5 space-y-1">{item.list.map((l) => <li key={l}>{l}</li>)}</ul>}
    {item.after?.map((p) => <p key={p}>{p}</p>)}
  </div>
);

export default function ExamPrep() {
  return (
    <div data-testid="exam-prep-page" className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
      <p className="font-mono text-xs uppercase tracking-widest" style={{ color: "var(--accent)" }}>RGA SSSA · Candidate preparation</p>
      <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-2">Exam Prep Advice</h1>
      <p data-testid="exam-prep-credit" className="mt-3 text-sm font-medium" style={{ color: "var(--ink-2)" }}>
        Tips courtesy of <span style={{ color: "var(--ink)" }}>Dr Greg Coates</span>: recurring examiner feedback from six examination reports (2023.2 to 2026.1).
      </p>
      <div className="mt-6 space-y-2 text-sm leading-relaxed" style={{ color: "var(--ink-2)" }}>{PREP_INTRO.map((p) => <p key={p}>{p}</p>)}</div>
      {PREP_GROUPS.map((g) => (
        <section key={g.group} className="mt-10">
          <h2 className="font-display text-base md:text-lg font-semibold mb-2">{g.group}</h2>
          <Accordion type="multiple" className="card px-4 sm:px-5">
            {g.items.map((it) => (
              <AccordionItem key={it.title} value={it.title} style={{ borderColor: "var(--line)" }}>
                <AccordionTrigger data-testid={`prep-heading-${slug(it.title)}`} className="text-left font-semibold hover:no-underline">{it.title}</AccordionTrigger>
                <AccordionContent data-testid={`prep-content-${slug(it.title)}`}><Body item={it} /></AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>
      ))}
      <blockquote data-testid="exam-prep-quote" className="mt-10 card p-5 flex gap-3 text-base font-display font-semibold">
        <Lightbulb size={20} className="shrink-0 mt-0.5" style={{ color: "var(--accent)" }} />“{PREP_QUOTE}”
      </blockquote>
      <p className="mt-6 text-xs" style={{ color: "var(--ink-3)" }}>Credit: Dr Greg Coates. Not an official ANZCA examination document.</p>
    </div>
  );
}
